export const getAllFaqs = (
    helpCenter: Queries.HelpCenterFieldsFragment
): Queries.FaqBlockFragment[] => {
    const helpCenterfaqs = helpCenter.faqs ?? [];

    const helpCenterTopics = helpCenter.helpCenterTopics;

    // get all the faqs from each help center topic, filtering out null or undefined faqs
    const topicFaqs =
        helpCenterTopics?.flatMap(
            (topic) =>
                topic?.faqs?.filter(
                    (faq): faq is Queries.FaqBlockFragment =>
                        faq !== null && faq !== undefined
                ) ?? []
        ) ?? [];

    // combine the faqs from the help center and the help center topics
    const allFaqs = helpCenterfaqs.concat(topicFaqs);

    // ensure allFaqs are unique based on faq.id
    const uniqueFaqs = Array.from(
        new Map(
            allFaqs
                .filter(
                    (faq): faq is Queries.FaqBlockFragment =>
                        faq !== null && faq !== undefined
                )
                .map((faq) => [faq.id, faq])
        ).values()
    );

    return uniqueFaqs as Queries.FaqBlockFragment[];
};

export const searchAllFaqs = (
    allFaqs: Queries.FaqBlockFragment[],
    searchTerm: string
): Queries.FaqBlockFragment[] => {
    const trimmedSearchTerm = searchTerm.trim().toLowerCase();

    if (!trimmedSearchTerm) {
        return [];
    }

    const searchTerms = trimmedSearchTerm.split(" ");

    return allFaqs.filter((faq) => {
        const question = faq.question?.toLowerCase() ?? "";
        const answer = faq.answer?.toLowerCase() ?? "";

        return searchTerms.every(
            (term) => question.includes(term) || answer.includes(term)
        );
    });
};
